import { caseStudies, pageAt, teamMembers } from "../content";
import { isJobPosting } from "../data/careers";
import { teamMemberAt } from "../data/team";
import { pathnameOf } from "./links";

// Some team profiles are not linked from About us; their slug ends in a role.
const teamRoleSlug =
  /-(intern|engineer|president|ceo|manager|representative|administrator|owner|assistant|analyst)\/?$/;

/** Classify a generic content page: "team" | "case" | "career" | "insight". */
export function articleKind(path) {
  // Pages written in content/ or added to the roster say what they are.
  const declared = pageAt(path)?.kind;
  if (declared) return declared;
  // The roster (data/team.js) first, then anyone the live About page linked.
  if (
    teamMemberAt(path) ||
    teamMembers.some((card) => pathnameOf(card.href) === path)
  )
    return "team";
  // Case studies come before the role-slug test: "…-lean-manufacturing-assistant"
  // is a case study, not a team member. Paginated duplicates (/slug/2/) count
  // as the case study itself.
  const canonical = path.replace(/\d+\/$/, "");
  if (caseStudies.some((card) => pathnameOf(card.href) === canonical))
    return "case";
  if (teamRoleSlug.test(path)) return "team";
  // Job postings: open positions plus past posting pages (data/careers.js).
  if (isJobPosting(path)) return "career";
  return "insight";
}

export const articleKindLabels = {
  team: "Our team",
  case: "Case study",
  career: "Careers",
  insight: "Insights",
};
